import { useStorage } from "app/custom-hooks/storage/useStorage";
import ConversionRateBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/components/ConversionRate";
import { companyAnalysisSessionStorage } from "app/pages/sales-intelligence/modules/company-analysis/services/storage/sessionStorage";

export const ConversionRateUpgradeBanner = () => {
    const [isSubmitted, setSubmitted] = useStorage<boolean>(
        companyAnalysisSessionStorage.conversionRateUpgradeHookSubmitted,
    );

    return (
        <ConversionRateBanner
            variant="company"
            isSubmitted={isSubmitted}
            onSubmit={() => setSubmitted(true)}
        />
    );
};
